import { useTranslation } from 'react-i18next';

export default function Problem() {
  const { t } = useTranslation();

  const problems = [
    {
      icon: 'ri-alert-line',
      title: t('problem.point1.title'),
      description: t('problem.point1.desc'),
    },
    {
      icon: 'ri-server-line',
      title: t('problem.point2.title'),
      description: t('problem.point2.desc'),
    },
    {
      icon: 'ri-global-line',
      title: t('problem.point3.title'),
      description: t('problem.point3.desc'),
    },
    {
      icon: 'ri-link-unlink',
      title: t('problem.point4.title'),
      description: t('problem.point4.desc'),
    },
  ];

  return (
    <section className="relative py-32 bg-white overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-slate-900 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            {t('problem.title')}
            <br />
            <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
              {t('problem.title2')}
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('problem.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-200 hover:border-red-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${problem.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{problem.title}</h3>
              <p className="text-gray-600 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
